import { RouteType } from "../../../types/RouteType";
import { JobsListStore } from "./ProjectsList.Store";
import { ProjectFormStore } from "./dialogs/ProjectForm/ProjectForm.Store";
import { RootStore } from "stores";

const projectsListRoute: RouteType = {
  name: "Projects",
  path: "/crm/projects",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Projects",
      component: () => import("./ProjectsList.Header"),
    },
    body: {
      grayBackground: true,
      component: () => import("./ProjectsList.Body"),
    },
  },
  group: 'CRM',
  requiresAuth: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load jobs data before entering the route
    const jobsListStore = rootStore.projectsListStore as JobsListStore;
    await jobsListStore.loadJobs();
    return true;
  },
  dialogs: [
    {
      name: "Project Form",
      component: () => import("./dialogs/ProjectForm/ProjectForm.Body"),
      title: "Project Form",
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const projectFormStore = rootStore.projectFormStore as ProjectFormStore;

        const result = await projectFormStore.saveProject();
        if (result) {
          // Refresh the jobs list after successful submission
          const jobsListStore =
            rootStore.projectsListStore as JobsListStore;
          await jobsListStore.reloadJobs();
        }
        return result;
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const projectFormStore = rootStore.projectFormStore as ProjectFormStore;
        return projectFormStore.isValid;
      },
    },
    {
      name: "projectDetail",
      component: () => import("./dialogs/ProjectDetail/ProjectDetail.Body"),
      title: "Project Details",
      cancelButton: true,
      height: 560,
    },
  ],
};

export default projectsListRoute;
